import { ReportSourceType } from "@/services/cloudchipr.api";
import { getLabelByBillingSourceType } from "@/components/utils/helpers/getLabelByBillingSourceType";
import { OneTimeReportType } from "@/components/pages/common/send-report/utils/types/types";

export const getOneTimeReportMessage = (
  sourceName: string,
  sourceId: string,
  sourceType: ReportSourceType,
  userEmail: string,
  reportType: OneTimeReportType,
) => {
  const reportUtl = `https://app.cloudchipr.com/resource-explorer/${sourceId}`;
  const dashboardUrl = `https://app.cloudchipr.com/dashboards/${sourceId}`;

  // DO NOT touch formating it will brake Slack messages
  return `<p style="margin-bottom: 0px; margin-top: 4px;">Hi,<br /><br />This ${reportType === "email" ? "email" : "message"} is sent from the Cloudchipr ${sourceType === "dashboard" ? "Dashboards" : "Billing Explorer"} page by user <a target="_blank" rel="noopener noreferrer nofollow" href=""><span>${userEmail}</span></a><br /><span>The</span> <a target="_blank" rel="noopener noreferrer nofollow" href="${sourceType === "dashboard" ? dashboardUrl : reportUtl}">${sourceName}</a> <span>${getLabelByBillingSourceType(sourceType)} in the attached file may need your attention. Please review and take the necessary actions.</span></p>`;
};
